
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  $refs!: {
    image: HTMLImageElement;
  };

  @Prop({required: true}) readonly dataSource: string;
  @Prop({required: true}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: 'li'}) readonly componentTag: string;

  private activeVersion: null | string = null;
  private defaultPlaceholder: string = '/area/web/default/assets/images/default-placeholder.png';

  private get listTypeClass(): string {
    switch (this.type) {
      case 'crosssell':
      case 'last-viewed':
      case 'slider':
        return '';
      case 'seo-with-product':
        return 'small-12';
      case 'home':
        return 'small-12 medium-6';
      default:
        return 'small-12 medium-8';
    }
  }

  private get productUrl(): string {
    if (this.activeVersion) {
      return this.product['url_key'] + '?version=' + this.activeVersion;
    }
    return this.product['url_key'];
  }

  private get imageWidth(): number {
    return 348;
  }

  private get imageHeight(): number {
    return 348;
  }

  private get swatches(): null | object {
    return this.product.hasOwnProperty('swatches') && Object.keys(JSON.parse(this.product['swatches'] || {})).length > 0 ?
        JSON.parse(this.product['swatches']) :
        null;
  }

  private get locale(): string {
    return window.Locale;
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }

  private get imageSrc(): string {
    if ( ! this.product['default_image']) {
      return this.defaultPlaceholder;
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${this.imageWidth}/h:${this.imageHeight}/extend:true/background:255:255:255/bl:10.0/q:40/path/media/catalog/product${this.product['default_image']['url']}`;
  }

  private get imageDataSrc(): string {
    if ( ! this.product['default_image']) {
      return this.defaultPlaceholder;
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${this.imageWidth}/h:${this.imageHeight}/extend:true/background:255:255:255/path/media/catalog/product${this.product['default_image']['url']} 1x,
    ${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${this.imageWidth * 2}/h:${this.imageHeight * 2}/extend:true/background:255:255:255/path/media/catalog/product${this.product['default_image']['url']} 2x`;
  }

  private created(): void {
    this.$eventBus.$on('change-image', (value: object, id: number) => {
      if (id !== this.product['product_id']) {
        return;
      }
      this.activeVersion = value['version'];
      let img = "";
      if (typeof value['image'] === 'undefined' || value['image'] === null || value['image'] === undefined) {
        img = `${this.$solarCdnBaseUrl}/area/web/default/assets/images/default-placeholder.png`;
      } else {
        img = `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${this.imageWidth}/h:${this.imageHeight}/extend:true/path/media/catalog/product${value['image']}`;
      }
      this.$refs.image.setAttribute('srcset', img);
    });
  }
}
